// extracted by mini-css-extract-plugin
export var addToCartButton = "_ti-b";
export var arrowButtonContainer = "_ti-9";
export var arrowButtonIcon = "_ti-a";
export var carouselArrowButton = "_ti-6";
export var carouselElementContainer = "_ti-1";
export var left = "_ti-7";
export var productDisplayCarouselContainer = "_ti-0";
export var productTileContainer = "_ti-2";
export var productTileImage = "_ti-4";
export var productTileImageContainer = "_ti-3";
export var productTileTitle = "_ti-5";
export var right = "_ti-8";
export var sliderOverflow = "_ti-c";